export default "__VITE_ASSET__CjZ7pyL6__"